module.exports = __webpack_public_path__ + "media/images/photos/usa-6269923e05ad3177ee3b27e6793db0de.jpg";